const translations = {
    skipForNow: 'Skip for now',
    takeMeThere: 'Take me there'
};

export default translations;
